import { type Middleware, type Dispatch } from "redux";

import { hooks } from "@/lib/hooks";
import { currentStepChanged } from "@/lib/VerificationService/VerificationServiceActions";
import { isSuccessResponse } from "@/lib/types/runtimeTypes";
import { type VerificationServiceValues, type VerificationServiceAction } from "@/lib/types/types";

export const verificationStoreMiddleware: Middleware<
  undefined,
  VerificationServiceValues,
  Dispatch<VerificationServiceAction>
> = (store) => (next) => (action: VerificationServiceAction) => {
  // 1. Capture state before the reducer runs
  const prevState = store.getState();

  // 2. Let the reducer process the action
  const result = next(action);

  // 3. Capture state after the reducer runs
  const nextState = store.getState();

  // 4. Perform side effects based on state changes
  if (action.type === "VERIFICATION_RESPONSE") {
    const { verificationResponse: prevResponse } = prevState;
    const { verificationResponse: nextResponse } = nextState;

    if (nextResponse && currentStepChanged(prevResponse, nextResponse)) {
      queueMicrotask(() => {
        if (isSuccessResponse(nextResponse)) {
          hooks.emit("ON_VERIFICATION_SUCCESS", nextResponse);
        }
        hooks.emit("ON_VERIFICATION_STEP_CHANGE", nextResponse);
      });
    }
  }

  return result;
};
